import { DashboardTileCategory } from '@zvoove-market/api';

export const dashboardTileCategoryDict = {
  [DashboardTileCategory.news]: () => $localize`:@@dashboardTile.category.news:News`,
  [DashboardTileCategory.produktupdate]: () => $localize`:@@dashboardTile.category.update:Produktupdate`,
  [DashboardTileCategory.seminar]: () => $localize`:@@dashboardTile.category.seminr:Seminar`,
  [DashboardTileCategory.webinar]: () => $localize`:@@dashboardTile.category.webinar:Webinar`,
  [DashboardTileCategory.whitepaper]: () => $localize`:@@dashboardTile.category.whitepaper:Whitepaper`,
  [DashboardTileCategory.blog]: () => $localize`:@@dashboardTile.category.blog:Blog`,
  [DashboardTileCategory.newsletter]: () => $localize`:@@dashboardTile.category.newsletter:Newsletter`,
  [DashboardTileCategory.aktuelles]: () => $localize`:@@dashboardTile.category.latestNews:Aktuelles`,
  [DashboardTileCategory.kundenevent]: () => $localize`:@@dashboardTile.category.customerEvent:Kundenevent`,
  [DashboardTileCategory.messe]: () => $localize`:@@dashboardTile.category.fair:Messe`,
  [DashboardTileCategory.stoerung]: () => $localize`:@@dashboardTile.category.disruption:Störung`,
  [DashboardTileCategory.video]: () => $localize`:@@dashboardTile.category.video:Video`,
  [DashboardTileCategory.backup]: () => $localize`:@@dashboardTile.category.backup:Backup`,
  [DashboardTileCategory.wissen]: () => $localize`:@@dashboardTile.category.knowledge:Wissen`,
};

export const dashboardTileCategoryItems = () =>
  Object.entries(dashboardTileCategoryDict).map((x) => ({
    id: parseInt(x[0], 10),
    name: x[1](),
  }));
